import React from 'react';
import gql from 'graphql-tag';
import moment from 'moment-timezone';
import { Query } from 'react-apollo';

import { buildQueryChild } from 'utils/queryHelpers';

import { AFTER_HOURS_EVENT_TYPE, STORE_HOURS_EVENT_TYPE } from './constants';

const queryName = 'compositions_TechAdmin_dealerScheduleDayQuery';

export const scheduleDayGql = gql`
  fragment ContactFields on AfterHoursContact {
    id
    name
    jobTitle
    primaryPhoneNumber
    secondaryPhoneNumber
  }

  fragment EventFields on AfterHoursEvent {
    id
    startDate startTime
    endDate endTime
    options { recurringStartDate recurringEndDate }
    recurring { dayOfWeek }
    isRecurring
    primaryContact { ...ContactFields }
    backupContact { ...ContactFields }
    finalContact { ...ContactFields }
  }

  query ${queryName} ($dealerId: ID!, $day: Date!) {
    calendarEvents (input: { dealerId: $dealerId, date: $day }) {
      events {
        __typename
        ... on ${STORE_HOURS_EVENT_TYPE} { start end }
        ... on ${AFTER_HOURS_EVENT_TYPE} {
          start end
          primaryContact { ...ContactFields }
          backupContact { ...ContactFields }
          finalContact { ...ContactFields }
          referenceDate: reference
          afterHoursEvent {
            ...EventFields
            exceptionsAndOverrides {
              ... on AfterHoursException {
                id
                daysOfWeek
                startDate
                endDate
                __typename
              }
              ... on AfterHoursEvent { # overrides
                ...EventFields
                __typename
              }
            }
          }
        }
      }
    }
  }
`;

function buildWrappedComponentWithQuery(WrappedComponent, componentProps) {
  const { day, dealer } = componentProps;
  const dealerId = dealer.id;

  return (
    <Query
      skip={!dealerId || !day}
      query={scheduleDayGql}
      variables={{ dealerId, day: moment(day).format('Y-MM-DD') }}
      fetchPolicy="cache-and-network"
    >
      {buildQueryChild(WrappedComponent, componentProps)}
    </Query>
  );
}

const withCalendarEvents = WrappedComponent => componentProps =>
  /* istanbul ignore next */
  buildWrappedComponentWithQuery(WrappedComponent, componentProps);

export default withCalendarEvents;



// WEBPACK FOOTER //
// ./src/compositions/TechAdmin/DealerDetails/RotationSchedulePanel/withCalendarEvents.js